import { useEffect, useState } from "react";
import { getLatestMagazines } from "../../../api/utils";

export const useLatestMagazines = (skipMagazineId, limit = 5) => {
  const [magazineIssues, setMagazineIssues] = useState([]);

  const fetchMagazineIssues = async () => {
    try {
      const response = await getLatestMagazines({ limit: skipMagazineId ? limit + 1 : limit });
      setMagazineIssues(response?.data);
    } catch (error) {
      console.error("Failed to fetch latest magazine issues:", error);
    }
  };

  useEffect(() => {
    fetchMagazineIssues();
  }, []);

  return magazineIssues;
};
